unit Client;
{

/* Initial. */

}
interface

uses
  WEBLib.Controls, WEBLib.REST, web, WEBLib.Dialogs, SysUtils,
  BaseRequest, BaseResponse, LoginResponse, TermListGetResponse, Utils;

type
  TResult = procedure(BaseResponse: TBaseResponse; const Boolean_Error: Boolean) of object;

  TClient = class(THttpRequest)
  private
    p_OnResult: TResult;
    p_String_BaseUrl: String;
    p_String_Language: String;
    p_String_LoginKey: String;
    p_String_LoginName: String;
    p_String_RequestClassName: String;
    p_String_UserName: String;
    p_String_UserFunction: String;
    procedure SetLanguage(const String_Language: String);
    procedure SetLoginKey(const String_LoginKey: String);
    procedure SetLoginName(const String_LoginName: String);
    procedure SetUserName(const String_UserName: String);
    procedure SetUserFunction(const String_UserFunction: String);
  public
    constructor Create(const String_UserName: String; const String_Password: String);
    property BaseUrl: String read p_String_BaseUrl;
    property Language: String read p_String_Language write SetLanguage;
    property LoginKey: String read p_String_LoginKey write SetLoginKey;
    property LoginName: String read p_String_LoginName write SetLoginName;
    property UserName: String read p_String_UserName write SetUserName;
    property UserFunction: String read p_String_UserFunction write SetUserFunction;
    function Call(const String_Call: String; const BaseRequest: TBaseRequest; const Boolean_ShowError: Boolean): Boolean;
    procedure ReturnAbort(Sender: TObject);
    procedure ReturnError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var Handled: Boolean);
    procedure ReturnResponse(Sender: TObject; AResponse: string);
    procedure ReturnTimeOut(Sender: TObject);
    property OnResult: TResult read p_OnResult write p_OnResult;
  end;

implementation

uses
  Config, LanguageTermList;

constructor TClient.Create(const String_UserName: String; const String_Password: String);
begin
  inherited Create(nil);

  Command := httpPOST;
  Headers.Add('Content-Type=application/json');
  Headers.Add('Authorization=Basic ' + EncodeBase64(String_UserName + ':' + String_Password));
  Timeout := 2000;

  // For now:
  p_String_BaseUrl := String_Server + '/erbasoft';

  OnAbort := ReturnAbort;
  OnError := ReturnError;
  OnResponse := ReturnResponse;
  OnTimeout := ReturnTimeOut;
end;

procedure TClient.SetLanguage(const String_Language: String);
begin
  p_String_Language := String_Language;
end;

procedure TClient.SetLoginKey(const String_LoginKey: string);
begin
  p_String_LoginKey := String_LoginKey;
end;

procedure TClient.SetLoginName(const String_LoginName: string);
begin
  p_String_LoginName := String_LoginName;
end;

procedure TClient.SetUserName(const String_UserName: string);
begin
  p_String_UserName := String_UserName;
end;

procedure TClient.SetUserFunction(const String_UserFunction: string);
begin
  p_String_UserFunction := String_UserFunction;
end;

function TClient.Call(const String_Call: String; const BaseRequest: TBaseRequest; const Boolean_ShowError: Boolean): Boolean;
begin
  try
    p_String_RequestClassName := BaseRequest.ClassType.ClassName;

    PostData := BaseRequest.ToJSON;
    Url := BaseUrl + String_Call;

    Execute;
  except
    ShowMessage('Execute error');
  end;
end;

procedure TClient.ReturnAbort(Sender: TObject);
begin
  ShowMessage('ReturnAbort');

  if Assigned(OnResult) then OnResult(nil, True);
end;

procedure TClient.ReturnError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord; var Handled: Boolean);
begin
  ShowMessage('ReturnError');

  if Assigned(OnResult) then OnResult(nil, True);
end;

procedure TClient.ReturnResponse(Sender: TObject; AResponse: string);
var BaseResponse: TBaseResponse;
begin
  if Assigned(OnResult) then
  begin
    if p_String_RequestClassName = 'TTermListGetRequest' then
      BaseResponse := TTermListGetResponse.Create(AResponse)
    else if p_String_RequestClassName = 'TLoginRequest' then
      BaseResponse := TLoginResponse.Create(AResponse);

    if (BaseResponse.Result.Code <> 'OK') then
    begin
      if (BaseResponse.Result.Message <> '') then
        ShowMessage(BaseResponse.Result.Message)
      else
        ShowMessage('Errors returned, for details see logging.');

      OnResult(nil, True)
    end
    else
      OnResult(BaseResponse, false)
  end;
end;

procedure TClient.ReturnTimeOut(Sender: TObject);
begin
  ShowMessage('ReturnTimeOut');

  if Assigned(OnResult) then OnResult(nil, True);
end;

end.
